import { useContext, useMemo } from 'react';
import { MDBIcon } from "mdb-react-ui-kit";
import useResumeExperiencesHandlers from "../../../context/resume/hooks/resume-experiences-handlers";
import { ResumeContext } from "../../../context/resume/resume-context";
import { TranslationContext } from "../../../context/translations/translations-context";
import { sortReferentialByTranslation } from "../../../utils/sortReferentialByTranslation";
import AddExperience from "./AddExperience";
import ExperienceItem from "./ExperienceItem";

export default function ExperienceList() {

    const { refActivitySectors, resumeData } = useContext(ResumeContext);
    const { translations, displayLanguage } = useContext( TranslationContext );
    const experiences = resumeData?.document?.experiences || [];
    const { handleAdd } = useResumeExperiencesHandlers();
    const experienceOrders = experiences.map( experience => experience.order );
    const sortedActivitySectors = useMemo(
        () => sortReferentialByTranslation( refActivitySectors, displayLanguage ),
        [ refActivitySectors, displayLanguage ]
    );

    return (
        <div>
            <div className="mb-3">
                <AddExperience insertionIndex={ 0 } experienceOrders={ experienceOrders }/>
            </div>
            {experiences?.map( ( experience, index ) => (
                <div key={ experience.order }>
                    <ExperienceItem
                        item={ experience }
                        refActivitySectors={ sortedActivitySectors }
                    />
                    { index < experiences.length - 1 && (
                        <div className="experience-insert-divider">
                            <button
                                type="button"
                                className="experience-insert-button"
                                onClick={ () => handleAdd( index + 1, experienceOrders ) }
                                title={ translations.experiencesSection.addExperienceHereLabel }
                                aria-label={ translations.experiencesSection.addExperienceHereLabel }
                            >
                                <MDBIcon fas icon="plus"/>
                            </button>
                        </div>
                    ) }
                </div>
            ) )}
            { experiences.length > 0 && (
                <AddExperience
                    insertionIndex={ experiences.length }
                    experienceOrders={ experienceOrders }
                />
            ) }
        </div>
    );
}
